export default __webpack_public_path__ + "static/media/close-purple.e4d319ad.svg";